import toIcon from '../toIcon';
import svg from './flag.svg';

export default toIcon(svg);
